<!--
    @Author : Luo
    @Time   : 2020/7/14 16:50
-->
<template>
  <div class="container">
    <page-header />
    <div class="page_content flex_center">
      <!-- 侧边栏 -->
      <template v-if="slideMenuVisible">
        <slide-menu />
      </template>
      <!-- 内容 -->
      <div class="page_main">
        <!-- 路由 -->
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import '@/components/common/common_style.css'
import pageHeader from '@/components/page-header/index'
import slideMenu from '@/components/slide-menu/index'

export default {
  name: 'home',
  data () {
    return {
      slideMenuVisible: true
    }
  },
  components: {
    pageHeader,
    slideMenu
  },
  mounted: function () {
    let that = this

    if (that.$route.query.account && that.$route.query.account === 'true') {
      that.slideMenuVisible = false
    }
  }
}
</script>

<style scoped>
.page_content {justify-content: flex-start;align-items: flex-start;min-height: calc(100vh - 80px);max-height: calc(100vh - 80px)}
.page_main {padding: 24px 28px;width: 100%;min-width: 1034px;overflow-y: scroll;min-height: calc(100vh - 120px);max-height: calc(100vh - 120px)}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue